// extracted by mini-css-extract-plugin
export default {"tablet_breakpoint":"768px","mobile_sm_breakpoint":"360px","mobile_xs_breakpoint":"320px"};